<div id="forms" class="page-layout simple fullwidth" fxLayout="column">

    <!-- HEADER -->
    <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
      <button mat-icon-button class="mr-16" [routerLink]="'/companies'">
              <mat-icon>arrow_back</mat-icon>
      </button>
      <h2 class="m-0">{{'TI_MANAGER.TITULO' | translate}}</h2>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content p-24">

        <p class="pt-16 pb-32">
            {{'TI_MANAGER.DESCRIPTION' | translate}}
        </p>

        <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">

            <!-- REACTIVE FORM EXAMPLE -->

            <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
                  fxFlex="1 0 auto" name="form" [formGroup]="form">

                <div class="h2 mb-24">{{'TI_MANAGER.DATOS' | translate}}</div>



                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                    <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                        <mat-label>{{'TI_MANAGER.NOMBRE' | translate}}</mat-label>
                        <input matInput formControlName="name" type="text" required value="{{datos.datosTI.nombreTI}}">
                        <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                        <mat-error>First Name is required!</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" fxFlex="50" class="pl-4">
                        <mat-label>{{'TI_MANAGER.APELLIDOS' | translate}}</mat-label>
                        <input matInput formControlName="lastname" type="text" required value="{{datos.datosTI.nombreTI}}">
                        <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                        <mat-error>Last Name is required!</mat-error>
                    </mat-form-field>

                </div>

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                    <mat-form-field appearance="outline" fxFlex="100">
                        <mat-label>{{'TI_MANAGER.EMAIL' | translate}}</mat-label>
                        <input matInput formControlName="email" type="email" required value="{{datos.datosTI.emailTI}}">
                        <mat-icon matSuffix class="secondary-text">email</mat-icon>
                        <mat-error>E-mail is required!</mat-error>
                    </mat-form-field>

                </div>


                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                    <mat-form-field appearance="outline" fxFlex="33">
                        <mat-label>{{'TI_MANAGER.TELEFONO' | translate}}</mat-label>
                        <input matInput formControlName="phone" type="number" maxlength="10" required value="{{datos.datosTI.telTI}}">
                        <mat-icon matSuffix class="secondary-text">phone</mat-icon>
                        <mat-error>Teléfono is required!</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" fxFlex="34" class="px-8">
                        <mat-label>{{'TI_MANAGER.EXTENSION' | translate}}</mat-label>
                        <input matInput formControlName="ext" type="text"  required value="{{datos.datosTI.extTI}}">
                        <mat-icon matSuffix class="secondary-text">phone</mat-icon>
                        <mat-error>Extensión is required!</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" fxFlex="33">
                        <mat-label>{{'TI_MANAGER.CELULAR' | translate}}</mat-label>
                        <input matInput formControlName="cellphone" type="number"
                                maxlength="10" required value="{{datos.datosTI.celTI}}">
                        <mat-icon matSuffix class="secondary-text">phonelink_ring</mat-icon>
                        <mat-hint align="end"></mat-hint>
                        <mat-error>Celular is required!</mat-error>
                    </mat-form-field>

                </div>

                <div *ngIf="show" fxLayout="row" fxLayoutAlign="end center" fxFlex="1 0 auto">
                    <button  mat-raised-button color="accent" (click)="registerManager();">Guardar</button>
                </div>
            </form>
        </div>
    </div>
    <!-- / CONTENT -->
</div>
